/* eslint-disable no-console */
/* global _HB_INTERVAL_SEC */
/* global _HB_TIMEBLOCK_SEC */
/* global _HB_API_URL */
import { currentUserIdSelector } from '../../ReduxStorage/Auth/selectors';
import { currentCohortSelector } from '../../ReduxStorage/Cohorts/selectors';
import {
  currentCourseSelector,
  selectCurrentCoursePath,
  selectCurrentCourseSubscriptionId,
} from '../../ReduxStorage/Courses/selectors';
import { selectCurrentInstitutionPath } from '../../ReduxStorage/Institutions/CurrentInstitutionPath/selectors';
import { selectCurrentPagePath } from '../../ReduxStorage/Pages/selectors';

let pageActiveTime = 0;
let pagePath = '';
let pulseOnLoadIntervalActive = false;
let sendPulseOnLoadInterval;
let pulsePeriodicalIntervalActive = false;
let sendPulsePeriodicallyInterval;
const SEC_TO_MS = 1000;
const CHECKING_INTERVAL = _HB_INTERVAL_SEC * SEC_TO_MS;

const getHttpRequest = () => {
  const httpRequest = new XMLHttpRequest();
  // httpRequest.onload = () => {
  //   console.log('success');
  // };
  // httpRequest.onerror = () => {
  //   console.log('error');
  // };
  httpRequest.open('POST', _HB_API_URL);
  httpRequest.timeout = 30000;
  return httpRequest;
};

const sendHBMetricsEnabled = (courseSelector) => () => {
  const learningTimeSettings = courseSelector.get('learningTimeSettings');
  return learningTimeSettings.get('isCollectingLearningTime');
};

const sendHeartBeatData = () => (dispatch, getState) => {
  const state = getState();
  const courseSelector = currentCourseSelector(state);

  if (!dispatch(sendHBMetricsEnabled(courseSelector)) || !_HB_API_URL) {
    return;
  }

  const heartBeatData = {
    data: {
      user_id: currentUserIdSelector(state),
      institution_id: selectCurrentInstitutionPath(state),
      course_id: currentCourseSelector(state).get('id'),
      subscription_id: selectCurrentCourseSubscriptionId(state),
      cohort_id: currentCohortSelector(state).get('id'),
      page_path: selectCurrentPagePath(state),
      heart_beat_timestamp: Date.now(),
    },
  };
  // request to Azure function
  const httpRequest = getHttpRequest();
  httpRequest.send(JSON.stringify(heartBeatData));
  // console.log(
  //   'URL',
  //   _HB_API_URL,
  //   'HB Data sent: ',
  //   heartBeatData,
  //   ' at ',
  //   new Date().toLocaleString()
  // );
};

const resetPageActiveTime = () => {
  pageActiveTime = 0;
};

const checkActiveTime = () => (dispatch) => {
  if (Math.round(pageActiveTime / _HB_TIMEBLOCK_SEC) > 0) {
    dispatch(sendHeartBeatData());
    resetPageActiveTime();
  }
};

const updatePagePath = (currentPagePath) => {
  pagePath = currentPagePath;
};

const sendPulsePeriodically = () => (dispatch, getState) => {
  pageActiveTime += _HB_INTERVAL_SEC;
  // if (pageActiveTime % 10 === 0) {
  //   console.log('interval', pageActiveTime);
  // }
  if (pageActiveTime % _HB_TIMEBLOCK_SEC === 0) {
    dispatch(sendHeartBeatData());
    resetPageActiveTime();
  }

  // to detect page path changes in blockpage
  const currentPagePath = selectCurrentPagePath(getState());
  if (pagePath !== currentPagePath) {
    resetPageActiveTime();
    updatePagePath(currentPagePath);
  }
};

const sendPulseOnLoad = () => (dispatch, getState) => {
  pulseOnLoadIntervalActive = true;
  const courseData = currentCourseSelector(getState());
  if (courseData) {
    dispatch(sendHeartBeatData());
    clearInterval(sendPulseOnLoadInterval);
    pulseOnLoadIntervalActive = false;
    sendPulsePeriodicallyInterval = setInterval(() => {
      dispatch(sendPulsePeriodically());
    }, CHECKING_INTERVAL);
    pulsePeriodicalIntervalActive = true;
  }
};

const resetActiveTime = () => (dispatch) => {
  dispatch(checkActiveTime());
  resetPageActiveTime();
  pulsePeriodicalIntervalActive = false;
  clearInterval(sendPulsePeriodicallyInterval);
};

export const pausePulse = () => (dispatch) => {
  if (pulseOnLoadIntervalActive) {
    clearInterval(sendPulseOnLoadInterval);
    pulseOnLoadIntervalActive = false;
  }
  if (pulsePeriodicalIntervalActive) {
    dispatch(resetActiveTime());
  }
};

export const startPulse = () => (dispatch, getState) => {
  if (document.hidden || pulsePeriodicalIntervalActive) {
    return;
  }
  const coursePath = selectCurrentCoursePath(getState());
  if (!coursePath) {
    return;
  }

  updatePagePath(selectCurrentPagePath(getState()));
  sendPulseOnLoadInterval = setInterval(() => {
    dispatch(sendPulseOnLoad());
  }, CHECKING_INTERVAL);
};
